import qs from 'qs';
import BaseComponent from 'foundation/base-component';
import app from 'general/js/app';
import Modal, { bemClasses } from 'general/js/modal';
import api, { isHtmlContentType } from 'general/js/api';
import pageSpinner from 'general/js/page-spinner';


export default class ModalTriggerComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.targetFromChildren = this.refs.target;
        this.targetSelector = this.element.dataset.target;

        this.modalTarget = null;
        this.modal = null;

        // try to get target synchronously
        this.modalTarget = this.getFromChildren();
        if (!this.modalTarget) {
            this.modalTarget = this.getFromTarget();
        }

        this.autoOpen = this.element.dataset.autoOpen === 'true' ||
            (this.modalTarget && this.modalTarget.dataset.autoOpen === 'true');

        this.isOpenning = false;
        this.onClick = this.onClick.bind(this);
        this.init();
    }

    init() {
        this.element.addEventListener('click', this.onClick);
        if (this.autoOpen) {
            this.open();
        }
    }

    open() {
        if (this.isOpenning) return;

        this.isOpenning = true;
        this.getModal().then((modal) => {
            try {
                modal.open();
                this.isOpenning = false;
                return Promise.resolve();
            } catch (error) {
                return Promise.reject(error);
            }
        }).catch(() => {
            this.isOpenning = false;
        });
    }

    getFromTarget() {
        return document.querySelector(this.targetSelector);
    }

    getFromChildren() {
        return this.targetFromChildren;
    }

    onClick(e) {
        e.preventDefault();
        if (!app.isEditMode) {
            this.open();
        }
    }

    getModal() {
        if (this.modal === null) {
            return this.getTarget().then((target) => {
                try {
                    this.modal = new Modal(target, {
                        bemList: [bemClasses.MOBILE_FIXED, bemClasses.AUTO]
                    });

                    return Promise.resolve(this.modal);
                } catch (error) {
                    return Promise.reject(error);
                }
            });
        }
        return Promise.resolve(this.modal);
    }

    onDestroy() {
        this.element.removeEventListener('click', this.onClick);
        this.modal = null;
    }

    getAsyncTargetUrl() {
        const targetUrl = this.element.getAttribute('href') || this.getAttribute(this.element, 'href');
        const openInPopupAttribute = this.element.getAttribute('data-dc-modal-trigger-cta-in-popup');
        const openInPopup = openInPopupAttribute !== null && openInPopupAttribute !== undefined ? openInPopupAttribute === 'True' ? true : false : null;

        if (targetUrl.indexOf('openPopup') !== -1) return targetUrl;

        if(openInPopup !== null) return openInPopup ? `${targetUrl}?openPopup=true` : targetUrl;

        return `${targetUrl}?openPopup=true`;
    }

    getTarget() {
        if (this.modalTarget) {
            return Promise.resolve(this.modalTarget);
        }

        let asyncTargetUrl = this.getAsyncTargetUrl();

        if (this.options.mergeQueryString) {
            const qsRegex = /([^\?]+)(\?(.*))?/;
            const parsedTargetUrl = asyncTargetUrl.match(qsRegex);
            const targetQueryString = qs.parse(parsedTargetUrl[3]);
            const locationQueryString = qs.parse(location.search, { ignoreQueryPrefix: true });
            const query = qs.stringify(Object.assign({}, targetQueryString, locationQueryString));

            asyncTargetUrl = parsedTargetUrl[1];

            if (query) {
                asyncTargetUrl += `?${query}`;
            }
        }

        if (asyncTargetUrl) {
            if (asyncTargetUrl.indexOf('openPopup') !== -1)
            {
                pageSpinner.show();
                return api.get(asyncTargetUrl).then((response) => {
                    if (isHtmlContentType(response)) {
                        return Promise.resolve(response.data);
                    }
                    return Promise.reject(new Error('unknown result from async data'));
                }).then((result) => {
                    pageSpinner.hide();
                    return Promise.resolve(result);
                }, (error) => {
                    pageSpinner.hide();
                    return Promise.reject(error);
                });
            }
            else
            {
                window.location.href = asyncTargetUrl;
            }
        }

        return Promise.reject();
    }
}
